/**
 * Two-letter initials from an email, for an avatar tile. Team members carry no display name
 * (`team.list` gives only `email`), so every "who manages billing" note (design o) draws its
 * initials from the local part: "ana.kowalska@…" → "AK", "ana@…" → "AN".
 */
export function emailInitials(email: string): string {
  const local = email.split('@')[0] ?? '';
  const parts = local.split(/[._-]+/).filter((part) => part !== '');
  const [first, second] = parts;
  if (first !== undefined && second !== undefined) {
    return `${first.charAt(0)}${second.charAt(0)}`.toUpperCase();
  }
  return (first ?? local).slice(0, 2).toUpperCase();
}
